module.exports = __webpack_public_path__ + "static/media/SFF_logo_2024.e4294b34.svg";